import { ajax, dateToString, debounced, appendGet } from "./utils";
import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import algoliasearch from 'algoliasearch/lite';
import Glide, { Breakpoints, Controls, Swipe } from "@glidejs/glide/dist/glide.modular.esm";
import ArrowDisabler from "./frontv2/ArrowDisabler";
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
import Wish from "./frontv2/Wish";
import { mapTilesStyle } from "./frontv2/map-utils";

const search = document.getElementById("searchPage");
if(search){
  var mapContainer = document.getElementById("map");
  var container = document.getElementById("experiencesContainer");
  var utm = container.dataset.utm ? container.dataset.utm : '';
  var body = document.body;
  var currencyInfos = {
    locale: body.dataset.currencyLocale.replace("_", "-"),
    rate: body.dataset.currencyRate,
    iso: body.dataset.currencyIso
  };

  var connected = body.dataset.connected === "true";

  //SESSION FILTERS
  var session = JSON.parse(body.dataset.session);
  let initAdults = document.getElementById('number-adults-more');
  let initChildren = document.getElementById('number-children-more');
  var sessionVars = {
    adults: initAdults ? initAdults.value : 0,
    children: initChildren ? initChildren.value : 0,
    langs: [],
    from: '',
    to: ''
  }

  const langsFilters = document.querySelectorAll("#languages .filter.lang-filter:checked");
  if (langsFilters) {
    langsFilters.forEach(function (lang) {
      sessionVars.langs.push(lang.dataset.id);
    });
  }

  //For algolia
  var currentDateSelected = null;
  var isMorning = false;
  var isAfternoon = false;
  var loadingOverlay = document.getElementById('overlay-loading');

  var locationSearchDone = (search.dataset.location === '' && search.dataset.activity === 'false') ? true : false;
}

// const debouncedSessionUpdate = debounced(300, function () {
//   updateSession();
// });
// debouncedSessionUpdate();

const initSearchBar = () => {
  const searchBarInput = document.querySelector("#aa-input-container input[type='search']");
  if(searchBarInput){
    searchBarInput.addEventListener("focus", function(){
      let isRegionSet = searchBarInput.dataset.regionSet && searchBarInput.dataset.regionSet === "true";
      if(isRegionSet){
        delete searchBarInput.dataset.regionSet;
        searchBarInput.value = '';
      }
    });
  }
}

const initFilters = () => {
  const filterTriggers = document.querySelectorAll(".toggleFilter");
  if (filterTriggers) {
    filterTriggers.forEach(function (filterTrigger) {
      let associatedFilter = filterTrigger.dataset.associatedFilter;
      let options = document.getElementById(associatedFilter);

      if (options) {
        filterTrigger.addEventListener("click", function () {
          options.classList.toggle("hidden");

          let icon = filterTrigger.querySelector("#toggleIcon");
          if(icon){
            icon.classList.toggle("icon-caret-down");
            icon.classList.toggle("icon-caret-up");
          }

          const activeFilters = filterTrigger.querySelector(".activeFilters");
          if (activeFilters) {
            activeFilters.classList.toggle("hidden");
          }
        });
      }
    });
  }

  const togglesFilters = document.querySelectorAll(".toggleFilters");
  const filters = document.getElementById("filters");
  if (togglesFilters && filters) {
    togglesFilters.forEach(function (toggleFilter) {
      toggleFilter.addEventListener("click", function () {
        filters.classList.toggle("opened");
      });
    });
  }

  const moreFilters = document.getElementById("moreFilters");
  const searchOverlay = document.querySelector(".search-overlay");

  if (moreFilters && filters && searchOverlay) {
    moreFilters.addEventListener("click", function () {
      if (!filters.classList.contains("opened")) {
        searchOverlay.classList.remove("md:hidden");
        searchOverlay.classList.add("md:block");

        overlayFilters.classList.add('active');
      }
      else {
        searchOverlay.classList.add("md:hidden");
        searchOverlay.classList.remove("md:block");

        setTimeout(function () {
          debouncedPerformSearch(algolia, map);
        }, 200);
      }

      filters.classList.toggle("opened");
    });

    searchOverlay.addEventListener("click", function () {
      filters.classList.remove("opened");
      searchOverlay.classList.toggle("md:hidden");
      searchOverlay.classList.toggle("md:block");

      debouncedPerformSearch(algolia, map);
    });
  }

  const inlineFilters = document.querySelectorAll(".inline-filter");
  if (inlineFilters && searchOverlay) {
    inlineFilters.forEach(function (inlineFilter) {
      const wrapper = inlineFilter.closest(".inlineFilters");
      if (wrapper) {
        wrapper.classList.add("z-40");
      }
      inlineFilter.addEventListener("click", function () {
        if (inlineFilter.parentNode.classList.contains("active")) {
          searchOverlay.classList.remove("md:hidden");
          searchOverlay.classList.add("md:block");
        }
        else {
          searchOverlay.classList.add("md:hidden");
          searchOverlay.classList.remove("md:block");
        }

        // setTimeout(function(){
        //   if(searchOverlay.classList.contains("md:hidden")){
        //     debouncedPerformSearch(algolia, map);
        //   }
        // },100);
      });
    });
  }

  const overlayFilters = document.querySelector('.overlay-filters');
  if(overlayFilters){
    overlayFilters.addEventListener('click', () => {
      if(overlayFilters.classList.contains('active')){
        overlayFilters.classList.remove('active');

        const currentFilterWindow = document.querySelector('.filter-window.opened');
        if(currentFilterWindow){
          const windowCloser = currentFilterWindow.querySelector('.filter-window-closer');
          if(windowCloser){
            windowCloser.dispatchEvent(new Event('click'));
          }
        }
      }
    });
  }

  //mobileResetFiltersALL MOBILE FILTERS
  const resets = document.querySelectorAll(".reset-filters");
  if (resets) {
    resets.forEach(reset => {
      reset.addEventListener("click", function () {
        if (filters) {
          const filtersToReset = document.querySelectorAll(".filter:checked");
          if (filtersToReset) {
            filtersToReset.forEach(function (filterToReset) {
              filterToReset.checked = false;
            });

            const filterWraps = document.querySelectorAll(".filterWrap");
            if (filterWraps) {
              filterWraps.forEach(function (filterWrap) {
                const activeFilters = filterWrap.querySelector(".activeFilters");
                if (activeFilters) {
                  if (activeFilters.id === "activeLanguagesText") {
                    activeFilters.innerHTML = `<span class="text-gray-500 text-sm">${activeFilters.dataset.defaultText}</span>`;
                  }
                  else {
                    activeFilters.textContent = activeFilters.dataset.defaultText;
                  }
                }
              });
            }
          }

          const personsInputs = document.querySelectorAll(".personsInput");
          if (personsInputs) {
            personsInputs.forEach(function (personsInput) {
              personsInput.value = 0;
              personsInput.dispatchEvent(new Event('change'));
            });

            activePersonsText();
          }

          const instantBook = filters.querySelector("#instantBook");
          if (instantBook) {
            instantBook.checked = false;
          }

          const priceSlider = filters.querySelector("#morePrice");
          if (priceSlider) {
            priceSlider.noUiSlider.set([0, body.dataset.highestPrice]);
            minPrice = 0;
            maxPrice = body.dataset.highestPrice;
          }

          const publicAndPrivate = filters.querySelector("#more-both");
          if (publicAndPrivate) {
            publicAndPrivate.checked = true;
          }

          const mobileFlatpickr = document.getElementById("mobileFlatpickr");
          if (mobileFlatpickr) {
            if (mobileFlatpickrInstance) {
              mobileFlatpickrInstance.clear();
            }
            delete mobileFlatpickr.dataset.activeDays;

            const mobileDateSetWrapper = document.getElementById("mobileDateSetWrapper");
            const hideOnDateSet = document.querySelectorAll(".hideOnDateSet");
            if (mobileDateSetWrapper && hideOnDateSet) {
              mobileDateSetWrapper.classList.add("hidden");

              hideOnDateSet.forEach(function (hide) {
                hide.classList.remove("hidden");
              });
            }
          }

          if(inlineDate){
            inlineDate.textContent = inlineDate.dataset.initialText;
            inlineDate.classList.remove("active");
          }

          if(clearDateButton){
            clearDateButton.dispatchEvent(new Event('click'));
          }

          //clear langs
          const clearLangsButton = document.querySelector('.clear-languages');
          if(clearLangsButton){
            clearLangsButton.dispatchEvent(new Event('click'));
          }

          const mobileLanguagesButton = document.getElementById('mobileLanguagesButton');
          if(mobileLanguagesButton){
            mobileLanguagesButton.classList.remove('active');
            mobileLanguagesButton.textContent = mobileLanguagesButton.dataset.initialText;
          }

          currentDateSelected = null;

          // const setActiveFilters = document.getElementById("setActiveFilters");
          // if (setActiveFilters) {
          //   setActiveFilters.textContent = setActiveFilters.dataset.defaultText;
          //   setActiveFilters.classList.remove("active");
          // }

          debouncedPerformSearch(algolia, map);
        }
      });
    });
  }

  const handleActiveLanguagesText = (languagesWrapper) => {
    const activeLanguages = languagesWrapper.querySelectorAll(".filter:checked");
    let text = ``;
    if (activeLanguages) {
      activeLanguages.forEach(function (activeLanguage) {
        let label = languagesWrapper.querySelector("label[for='" + activeLanguage.id + "']");
        text += `<div class="flex items-center mr-2 mt-1">
                    ${label.innerHTML}
                  </div>`;
      });
    }

    const activeLanguagesText = document.getElementById("activeLanguagesText");
    if (activeLanguagesText) {
      if (text.length) {
        activeLanguagesText.innerHTML = text;
      }
      else {
        activeLanguagesText.innerHTML = `<span class="text-gray-500 text-sm">${activeLanguagesText.dataset.defaultText}</span>`;
      }
    }
  }

  if (filters) {

    const handleActiveFiltersText = (filterWrap) => {
      const activeFiltersDOM = filterWrap.querySelector(".activeFilters:not(.activeLangs)");
      if (activeFiltersDOM) {
        // let activeFilters = filterWrap.querySelectorAll(".active");
        let activeFilters = filterWrap.querySelectorAll(".filter:checked");
        if (activeFilters) {
          let textActive = [];
          activeFilters.forEach(function (activeFilter) {
            if (textActive.length > 2) {
              return;
            }
            const label = filterWrap.querySelector("label[for='" + activeFilter.id + "']")
            textActive.push(label.textContent);
          });

          if (textActive.length > 2) {
            textActive.push("...");
          }
          else if (textActive.length === 0) {
            textActive.push(activeFiltersDOM.dataset.defaultText);
          }
          activeFiltersDOM.textContent = textActive.join(", ");
        }
      }
    }

    //Mobile Text Active Filters
    const _filters = document.querySelectorAll(".filterWrap .filter");
    if (_filters) {
      _filters.forEach(function (_filter) {
        const wrapper = _filter.closest(".filterWrap");
        _filter.addEventListener("click", function () {
          if (wrapper) {
            handleActiveFiltersText(wrapper);
          }
        });

        //AT PAGE LOADING (IN CASE OF GET PARAMS)
        handleActiveFiltersText(wrapper);
      });
    }

    // const languages = document.getElementById("languages");
    const languageWrappers = document.querySelectorAll(".langsWrapper");
    if (languageWrappers) {
      languageWrappers.forEach(langWrapper => {
        const langs = langWrapper.querySelectorAll(".filter");
        if (langs) {
          langs.forEach(function (lang) {
            lang.addEventListener("click", function () {
              handleActiveLanguagesText(langWrapper);
            });
          });
        }

        handleActiveLanguagesText(langWrapper);
      });
    }

    // const allFilters = filters.querySelectorAll(".filter");
    // if (allFilters) {
    //   allFilters.forEach(function (_filter) {
    //     _filter.addEventListener("click", function () {
    //       nbOfActiveFilters(filters);
    //     });
    //   });
    // }

    // const inputsPersons = filters.querySelectorAll(".personsInput");
    // if (inputsPersons) {
    //   inputsPersons.forEach(function (inputPersons) {
    //     inputPersons.addEventListener("change", function () {
    //       nbOfActiveFilters(filters);
    //     });
    //   });
    // }

    // const instantBook = filters.querySelector("#instantBook");
    // if (instantBook) {
    //   instantBook.addEventListener("click", function () {
    //     nbOfActiveFilters(filters);
    //   });
    // }

    //TODO trouver le bug (nombre de filtres actifs - 1)
    // const nbOfActiveFilters = (filters) => {
      //For mobile active filters text
      // setTimeout(function(){
      //   const activeMobileFiltersContainer = document.getElementById("activeMobileFilters");
      //   let text = [];

      //   let nbOfActiveFilters = 0;
      //   const allActiveFilters = filters.querySelectorAll(".filter:checked");
      //   if (allActiveFilters) {
      //     nbOfActiveFilters += allActiveFilters.length;
      //     allActiveFilters.forEach(function (activeFilter) {
      //       if (activeFilter.classList.contains("date") || activeFilter.classList.contains("lang-filter")) {
      //         text.push(activeFilter.dataset.name);
      //       }
      //     });
      //   }

      //   const mobileDateSetWrapper = filters.querySelector("#mobileDateSetWrapper");
      //   if(mobileDateSetWrapper && !mobileDateSetWrapper.classList.contains("hidden")){
      //     nbOfActiveFilters++;
      //   }
      //   // if(mobileDateSetWrapper && !mobileDateSetWrapper.classList.contains("hidden")){
      //   //   nbOfActiveFilters++;
      //   // }

      //   const personsInputAdult = filters.querySelector("#number-adults-more");
      //   const personsInputChildren = filters.querySelector("#number-children-more");
      //   if (personsInputAdult && personsInputChildren && (personsInputAdult.value != 0 || personsInputChildren.value != 0)) {
      //     nbOfActiveFilters++;
      //     let persons = parseInt(personsInputAdult.value) + parseInt(personsInputChildren.value);
      //     if (persons === 1) {
      //       text.push(activeMobileFiltersContainer.dataset.person);
      //     }
      //     else {
      //       text.push(activeMobileFiltersContainer.dataset.persons.replace("{0}", persons));
      //     }
      //   }

      //   const instantBook = filters.querySelector("#instantBook");
      //   if (instantBook && instantBook.checked) {
      //     nbOfActiveFilters++;
      //   }

      //   if (minPrice !== 0 && maxPrice !== body.dataset.highestPrice) {
      //     nbOfActiveFilters++;
      //   }

      //   // const setActiveFilters = document.getElementById("setActiveFilters");
      //   // if (setActiveFilters) {
      //   //   if (nbOfActiveFilters > 0) {
      //   //     setActiveFilters.textContent = setActiveFilters.dataset.defaultText + " • " + nbOfActiveFilters;
      //   //     setActiveFilters.classList.add("active");
      //   //   }
      //   //   else {
      //   //     setActiveFilters.textContent = setActiveFilters.dataset.defaultText;
      //   //     setActiveFilters.classList.remove("active");
      //   //   }
      //   // }

      //   if (activeMobileFiltersContainer) {
      //     if (text.length) {
      //       if (text.length > 5) {
      //         text = text.slice(0, 5);
      //         text.push("...");
      //       }

      //       text = text.join(" • ");
      //       activeMobileFiltersContainer.textContent = text;
      //     }
      //     else {
      //       activeMobileFiltersContainer.textContent = activeMobileFiltersContainer.dataset.initialText;
      //     }
      //   }
      // }, 100);
    // }

    // nbOfActiveFilters(filters);
  }

  // window.addEventListener('click', function (e) {
  //   if (filters && moreFilters && toggleFilters && searchOverlay) {
  //     if (!filters.contains(e.target) && !moreFilters.contains(e.target) && !toggleFilters.contains(e.target) && filters.classList.contains("opened")) {
  //       filters.classList.toggle("opened");
  //       searchOverlay.classList.toggle("md:hidden");
  //       searchOverlay.classList.toggle("md:block");

  //       debouncedPerformSearch(algolia, map);
  //     }
  //   }
  // });


  //--------------------------FLATPICKR MOBILE AND DESKTOP----------------------------

  flatpickr.localize(flatpickrLanguages[body.dataset.lang.substr(0, 2)]);

  const onDateChange = (selectedDates, inlineDate) => {
    const locale = body.dataset.lang.replace("_", "-");
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const date = new Date(selectedDates[0]).toLocaleDateString(locale, options);
    // const dateEnd = new Date(selectedDates[1]).toLocaleDateString(locale, options);

    // if (dateStart !== dateEnd) {
    //   inlineDate.textContent = dateStart + " • " + dateEnd;
    // }
    // else {
    inlineDate.textContent = date;
    // }
    inlineDate.classList.add("active");
  }

  // const getDaysOfWeekBetweenTwoDates = (dates) => {
  //   let daysOfWeek = [];
  //   let startDate = dates[0];
  //   let endDate = dates[1];
  //   startDate.setHours(0, 0, 0, 0);

  //   const oneDay = 24 * 60 * 60 * 1000;
  //   const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay));
  //   if (diffDays < 7) {
  //     for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
  //       let day = new Date(d).getDay();
  //       if (day === 0) {
  //         day = 7;
  //       }

  //       if (daysOfWeek.indexOf(day) === -1) {
  //         daysOfWeek.push(day);
  //       }
  //     }
  //   }
  //   else {
  //     daysOfWeek.push(1, 2, 3, 4, 5, 6, 7);
  //   }

  //   return daysOfWeek;
  // }


  var inlineFlatpickrInstance = null;
  const inlineDate = document.getElementById("inlineDate");
  if (inlineDate) {
    let defaultDate = new Date();
    if(search.dataset.date && search.dataset.date !== 'false'){
      defaultDate = new Date(search.dataset.date);
    }
    else if (session && session.from) {
      defaultDate = new Date(session.from);
    }

    inlineDate.addEventListener("click", function () {
      const flatpickrInline = document.querySelector(".flatpickr-inline");
      if (flatpickrInline && !inlineFlatpickrInstance) {
        let minDate = new Date();
        minDate.setHours(0, 0, 0);

        inlineFlatpickrInstance = flatpickr(flatpickrInline, {
          inline: true,
          minDate: minDate,
          dateFormat: "Y-m-d",
          defaultDate: defaultDate,
          showMonths: flatpickrInline.dataset.showMonths,
          // mode: "range",
          onChange: function (selectedDates) {
            if (selectedDates.length && selectedDates[0]) {
              sessionVars.from = selectedDates[0];
              currentDateSelected = selectedDates[0];
              // sessionVars.to = selectedDates[1];
              // updateSession();

              onDateChange(selectedDates, inlineDate);

              if(mobileDateSet){
                onMobileDateChange(selectedDates, mobileDateSet);
              }

              let daysOfWeek = JSON.stringify([selectedDates[0].getDay()]);
              if (moreFlatpickrInstance && flatpickrMoreFilters) {
                moreFlatpickrInstance.setDate(selectedDates);
                flatpickrMoreFilters.dataset.activeDays = daysOfWeek;
              }

              if(flatpickrMobile && mobileFlatpickrInstance){
                mobileFlatpickrInstance.setDate(selectedDates);
                flatpickrMobile.dataset.activeDays = daysOfWeek;
              }
            }
          },
          // if (selectedDates.length && selectedDates[0]) {
          //   sessionVars.from = selectedDates[0];
          //   currentDateSelected = selectedDates[0];
          //   // sessionVars.to = selectedDates[1];
          //   updateSession();

          //   if (inlineDate) {
          //     onDateChange(selectedDates, inlineDate);
          //   }
          //   if (inlineFlatpickrInstance) {
          //     inlineFlatpickrInstance.setDate(selectedDates);
          //   }

          //   onMobileDateChange(selectedDates, mobileDateSet);

          //   // let daysOfWeek = JSON.stringify(getDaysOfWeekBetweenTwoDates(selectedDates));
          //   let daysOfWeek = JSON.stringify([selectedDates[0].getDay()]);
          //   flatpickrMobile.dataset.activeDays = daysOfWeek;
          //   if (flatpickrMoreFilters) {
          //     flatpickrMoreFilters.dataset.activeDays = daysOfWeek;
          //   }
          // }
          onReady: function (a, b, f) {
            if ((search.dataset.date && search.dataset.date !== 'false') || (session && session.from)) {
              f.setDate(f.config.defaultDate, true);
            }
          }
        });
      }
    });

    var moreFlatpickrInstance = null;
    const flatpickrMoreFilters = document.getElementById("flatpickr-more");
    if (flatpickrMoreFilters) {
      let minDate = new Date();
      minDate.setHours(0, 0, 0);

      moreFlatpickrInstance = flatpickr(flatpickrMoreFilters, {
        inline: true,
        minDate: minDate,
        dateFormat: "Y-m-d",
        defaultDate: defaultDate,
        // mode: "range",
        onChange: function (selectedDates) {
          if (selectedDates.length && selectedDates[0]) {
            sessionVars.from = selectedDates[0];
            currentDateSelected = selectedDates[0];
            // sessionVars.to = selectedDates[1];
            // updateSession();

            onDateChange(selectedDates, inlineDate);
            if (inlineFlatpickrInstance) {
              inlineFlatpickrInstance.setDate(selectedDates);
            }

            // let daysOfWeek = getDaysOfWeekBetweenTwoDates(selectedDates);
            let daysOfWeek = JSON.stringify([selectedDates[0].getDay()]);
            flatpickrMoreFilters.dataset.activeDays = daysOfWeek;
          }
        },
        onReady: function (a, b, f) {
          if ((search.dataset.date && search.dataset.date !== 'false') || (session && session.from)) {
            f.setDate(f.config.defaultDate, true);
          }
        }
      });
    }
  }

  const clearDateButton = document.getElementById("inlineClearDate");
  const flatpickrMoreFilters = document.getElementById("flatpickr-more");
  if (clearDateButton && inlineDate && flatpickrMoreFilters) {
    clearDateButton.addEventListener("click", function () {
      inlineFlatpickrInstance.clear();
      moreFlatpickrInstance.clear();
      delete flatpickrMoreFilters.dataset.activeDays;

      inlineDate.textContent = inlineDate.dataset.initialText;
      inlineDate.classList.remove("active");

      sessionVars.from = '';
      sessionVars.to = '';
      // debouncedSessionUpdate();

      // const clearMobileCalendar = document.getElementById("clearMobileCalendar");
      if(typeof clearMobileCalendar !== 'undefined'){
        clearMobileCalendar[0].dispatchEvent(new Event('click'));
      }

      currentDateSelected = null;
    });
  }

  //-----MOBILE------\\

  const toggleDateSetWrapper = (mobileDateSet, hideTap) => {
    const wrapper = mobileDateSet.closest("#mobileDateSetWrapper");
    if (wrapper) {
      if (hideTap) {
        wrapper.classList.remove("hidden");
      }
      else {
        wrapper.classList.add("hidden");
      }
    }

    const hideOnDateSet = document.querySelectorAll(".hideOnDateSet");
    if (hideOnDateSet) {
      hideOnDateSet.forEach(function (hide) {
        if (hideTap) {
          hide.classList.add("hidden");
        }
        else {
          hide.classList.remove("hidden");
        }
      });
    }
  }

  const onMobileDateChange = (selectedDates, mobileDateSet) => {
    const locale = body.dataset.lang.replace("_", "-");
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const date = new Date(selectedDates[0]).toLocaleDateString(locale, options);
    // const dateEnd = new Date(selectedDates[1]).toLocaleDateString(locale, options);

    // if (dateStart !== dateEnd) {
    //   mobileDateSet.textContent = dateStart + " • " + dateEnd;
    // }
    // else {
    mobileDateSet.textContent = date;
    // }

    toggleDateSetWrapper(mobileDateSet, true);
  }

  const calendarOpeners = document.querySelectorAll(".mobileOpenCalendar");
  const mobileCalendar = document.getElementById("mobileCalendar");
  if (calendarOpeners && mobileCalendar) {
    calendarOpeners.forEach(function (calendarOpener) {
      calendarOpener.addEventListener("click", function () {
        mobileCalendar.classList.add("opened");
        overlayFilters.classList.add('active');
      });
    });
  }

  var mobileFlatpickrInstance = null;
  const flatpickrMobile = document.getElementById("mobileFlatpickr");
  const openCalendar = document.getElementById("openCalendar");
  const mobileDateSet = document.getElementById("mobileDateSet");
  if (flatpickrMobile && openCalendar && mobileDateSet) {
    // openCalendar.addEventListener("click", function () {
    if (!mobileFlatpickrInstance) {
      let defaultDate = new Date();
      if(search.dataset.date && search.dataset.date !== 'false'){
        defaultDate = new Date(search.dataset.date);
      }
      else if (session && session.from) {
        defaultDate = new Date(session.from);
      }

      let minDate = new Date();
      minDate.setHours(0, 0, 0);

      mobileFlatpickrInstance = flatpickr(flatpickrMobile, {
        inline: true,
        minDate: minDate,
        dateFormat: "Y-m-d",
        defaultDate: defaultDate,
        // mode: "range",
        onChange: function (selectedDates) {
          if (selectedDates.length && selectedDates[0]) {
            sessionVars.from = selectedDates[0];
            currentDateSelected = selectedDates[0];
            // sessionVars.to = selectedDates[1];
            // updateSession();

            if (inlineDate) {
              onDateChange(selectedDates, inlineDate);
            }
            if (inlineFlatpickrInstance) {
              inlineFlatpickrInstance.setDate(selectedDates);
            }

            onMobileDateChange(selectedDates, mobileDateSet);

            // let daysOfWeek = JSON.stringify(getDaysOfWeekBetweenTwoDates(selectedDates));
            let daysOfWeek = JSON.stringify([selectedDates[0].getDay()]);
            flatpickrMobile.dataset.activeDays = daysOfWeek;
            if (flatpickrMoreFilters) {
              flatpickrMoreFilters.dataset.activeDays = daysOfWeek;
            }
          }
        },
        onReady: function (a, b, f) {
          if ((search.dataset.date && search.dataset.date !== 'false') || (session && session.from)) {
            f.setDate(f.config.defaultDate, true);
          }
        }
      });
    }
    // });

    // const clearMobileCalendar = document.getElementById("clearMobileCalendar");
    const clearMobileCalendarButtons = document.querySelectorAll(".clear-mobile-calendar");
    if (clearMobileCalendarButtons && mobileDateSet && flatpickrMobile) {
      clearMobileCalendarButtons.forEach(clearMobileCalendar => {
        clearMobileCalendar.addEventListener("click", function () {
          if (mobileFlatpickrInstance) {
            mobileFlatpickrInstance.clear();
            delete flatpickrMobile.dataset.activeDays;

            toggleDateSetWrapper(mobileDateSet, false);

            sessionVars.from = '';
            sessionVars.to = '';
            // debouncedSessionUpdate();

            //Set date selected to null to not trigger an ajax call verifying timeslots
            currentDateSelected = null;
          }

          if(inlineFlatpickrInstance){
            inlineFlatpickrInstance.clear();
          }

          if(inlineDate){
            inlineDate.textContent = inlineDate.dataset.initialText;
            inlineDate.classList.remove("active");
          }
        });
      });
    }

    const mobileFilterOpeners = document.querySelectorAll(".filter-window-opener");
    if(mobileFilterOpeners){
      mobileFilterOpeners.forEach(opener => {
        const filterWindow = document.getElementById(opener.dataset.filterWindow);
        if(filterWindow){
          opener.addEventListener('click', () => {
            overlayFilters.classList.add('active');
            filterWindow.classList.add('opened');
          });
        }
      });
    }

    const mobileFilterClosers = document.querySelectorAll(".filter-window-closer");
    if (mobileFilterClosers) {
      mobileFilterClosers.forEach(function (mobileFilterCloser) {
        const filterWindow = mobileFilterCloser.closest('.filter-window');
        if(filterWindow){
          mobileFilterCloser.addEventListener("click", function () {
            filterWindow.classList.remove("opened");

            if(!filters.classList.contains('opened')){
              overlayFilters.classList.remove('active');
            }

            if(mobileFilterCloser.classList.contains('trigger-search')){
              setTimeout(function(){
                debouncedPerformSearch(algolia, map);
              }, 200);
            }
          });
        }
      });
    }

    const resetMobilePersons = document.getElementById('reset-persons');
    if(resetMobilePersons){
      const personsInputs = document.querySelectorAll(".personsInput");
      if (personsInputs) {
        resetMobilePersons.addEventListener('click', () => {
          personsInputs.forEach(function (personsInput) {
            personsInput.value = 0;
            personsInput.dispatchEvent(new Event('change'));
          });

          activePersonsText();
        });
      }
    }

    const resetLanguages = document.getElementById('reset-languages');
    if(resetLanguages){
      resetLanguages.addEventListener('click', () => {
        const filtersToReset = document.querySelectorAll("#langsFilterWindow .filter:checked, #languages .filter:checked");
        if (filtersToReset) {
          filtersToReset.forEach(function (filterToReset) {
            filterToReset.checked = false;
            filterToReset.nextElementSibling.classList.remove('active');
          });
        }

        const activeLanguagesText = document.getElementById("activeLanguagesText");
        if (activeLanguagesText) {
          activeLanguagesText.innerHTML = `<span class="text-gray-500 text-sm">${activeLanguagesText.dataset.defaultText}</span>`;
        }

        const mobileLanguagesButton = document.getElementById('mobileLanguagesButton');
        if(mobileLanguagesButton){
          mobileLanguagesButton.classList.remove('active');
          mobileLanguagesButton.textContent = mobileLanguagesButton.dataset.initialText;
        }
      });
    }
  }

  //--------------------------END FLATPICKR MOBILE AND DESKTOP----------------------------

  //--------------------------PRICE SLIDERS----------------------------

  const priceSliders = document.querySelectorAll(".priceSlider");
  if (priceSliders) {
    priceSliders.forEach(function (priceSlider) {
      noUiSlider.create(priceSlider, {
        start: [0, parseInt(body.dataset.highestPrice)],
        connect: true,
        tooltips: [true, true],
        range: {
          'min': 0,
          'max': parseInt(body.dataset.highestPrice)
        },
        format: {
          to: function (value) {
            let formattedPrice = new Intl.NumberFormat(currencyInfos.locale, {
              style: 'currency',
              currency: currencyInfos.iso,
              minimumFractionDigits: 0 })
              .format(parseInt(value) * currencyInfos.rate);

            return formattedPrice;
          },
          from: function (value) {
            return parseInt(value);
          }
        }
      });
    });
  }

  const inlinePriceSlider = document.getElementById("inlinePrice");
  const morePriceSlider = document.getElementById("morePrice");
  if (inlinePriceSlider && morePriceSlider) {
    const inlinePriceDisplay = inlinePriceSlider.closest(".dropdown").querySelector(".inline-filter");
    inlinePriceSlider.noUiSlider.on("change", (values, handle, unencoded) => {
      priceUpdate(morePriceSlider.noUiSlider, inlinePriceDisplay, values, unencoded);
    });
    morePriceSlider.noUiSlider.on("change", (values, handle, unencoded) => {
      priceUpdate(inlinePriceSlider.noUiSlider, inlinePriceDisplay, values, unencoded);
    });
  }

  const priceUpdate = (slider, inlinePriceDisplay, values, unencoded) => {
    slider.set([parseInt(unencoded[0]), parseInt(unencoded[1])]);
    minPrice = parseInt(unencoded[0]);
    maxPrice = parseInt(unencoded[1]);
    if (inlinePriceDisplay) {
      inlinePriceDisplay.textContent = values[0] + " • " + values[1];
      inlinePriceDisplay.classList.add("active");
    }
  }

  //--------------------------END PRICE SLIDERS----------------------------

  // const inlineFilters = document.querySelectorAll(".inline-filter");
  // if (inlineFilters) {
  //   inlineFilters.forEach(function (inlineFilter) {
  //     inlineFilter.addEventListener("click", function () {
  //       searchOverlay.classList.toggle("md:hidden");
  //       searchOverlay.classList.toggle("md:block");
  //     });
  //   });
  // }

  //---------------SYNC BETWEEN INLINE AND MORE FILTERS----------------

  const filterButtons = document.querySelectorAll(".filter");
  if (filterButtons) {
    filterButtons.forEach(function (filterButton) {
      filterButton.addEventListener("click", function () {
        var linkedFilter;
        if(filterButton.hasAttribute('data-direct-linked-filter')){
          linkedFilter = document.getElementById(filterButton.dataset.directLinkedFilter);
        }
        else{
          let linkedFilterData = filterButton.dataset.linkedFilter;
          if (linkedFilterData) {
            let where = filterButton.closest(".wrap").dataset.toggleIn;
            linkedFilter = document.querySelector("." + where + " [data-linked-filter=" + linkedFilterData + "]");
          }
        }

        if (linkedFilter) {
          linkedFilter.checked = this.checked;
          setActiveFilter(filterButton.parentNode);
          handleActiveLanguagesText(filterButton.parentNode);
        }

        if (filterButton.classList.contains("lang-filter")) {
          let index = sessionVars.langs.indexOf(filterButton.dataset.id);
          if (index === -1 && this.checked) {
            sessionVars.langs.push(filterButton.dataset.id);
          }
          else if (index !== -1 && !this.checked) {
            sessionVars.langs.splice(index, 1);
          }

          // debouncedSessionUpdate();
        }
      });
    });
  }

  const radios = document.querySelectorAll("input[type='radio']");
  if (radios) {
    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        const linkedRadio = document.getElementById(this.dataset.linkedTo);
        if (linkedRadio) {
          linkedRadio.checked = true;
        }
      });
    });
  }

  //---------------END SYNC BETWEEN INLINE AND MORE FILTERS-------------

  //------------------SAVE AND CLEAR BUTTONS LOGIC----------------------

  const saveButtons = document.querySelectorAll(".save");
  if (saveButtons) {
    saveButtons.forEach(function (saveButton) {
      const dropdown = saveButton.closest(".dropdown");
      if (dropdown) {
        saveButton.addEventListener("click", function () {
          dropdown.classList.toggle("active");
          if (searchOverlay) {
            searchOverlay.classList.remove("md:block");
            searchOverlay.classList.add("md:hidden");
          }

          debouncedPerformSearch(algolia, map);
        });
      }
    });
  }

  const clearButtons = document.querySelectorAll(".clear");
  if (clearButtons) {
    clearButtons.forEach(function (clearButton) {
      const dropdownContainer = clearButton.closest(".dropdown-container");
      if (dropdownContainer) {
        const defaultsFilters = dropdownContainer.querySelectorAll("[data-default]");
        if (defaultsFilters) {
          clearButton.addEventListener("click", function () {
            const activeFilters = dropdownContainer.querySelectorAll(".filter:checked");
            if (activeFilters) {
              activeFilters.forEach(function (activeFilter) {
                if (!activeFilter.dataset.default) {
                  activeFilter.checked = false;
                }
              });
            }
            defaultsFilters.forEach(function (defaultFilter) {
              defaultFilter.checked = true;
            });

            const dropdown = clearButton.closest(".dropdown");
            if (dropdown) {
              setActiveFilter(dropdown);
            }

            if (!this.dataset.multipleClear) {
              const alsoClearWrapper = document.getElementById(this.dataset.clear);
              clearFilters(alsoClearWrapper);
            }
            else {
              const alsoClearWrappers = JSON.parse(this.dataset.clear);
              if (alsoClearWrappers) {
                alsoClearWrappers.forEach(function (wrapper) {
                  const alsoClear = document.getElementById(wrapper);
                  clearFilters(alsoClear);
                });
              }
            }

            if (clearButton.classList.contains("clear-languages")) {
              sessionVars.langs = [];
              // debouncedSessionUpdate();
            }
          });
        }
      }
    });
  }

  const clearFilters = (wrapper) => {
    if (wrapper) {
      const filtersToClear = wrapper.querySelectorAll(".filter:checked");
      if (filtersToClear) {
        filtersToClear.forEach(function (filterToClear) {
          filterToClear.checked = false;
        });
      }
    }
  }

  const closeFilters = document.querySelectorAll(".closeFilters");
  if (closeFilters && filters && searchOverlay) {
    closeFilters.forEach(function (closeFilter) {
      closeFilter.addEventListener("click", function () {
        filters.classList.remove("opened");
        searchOverlay.classList.toggle("md:hidden");
        searchOverlay.classList.toggle("md:block");
        overlayFilters.classList.remove('active');

        if(closeFilter.dataset.trigger || closeFilter.classList.contains('trigger-search')){
          setTimeout(function(){
            debouncedPerformSearch(algolia, map);
          }, 200);
        }

        const mobileFilterWindows = document.querySelectorAll(".filter-window");
        if(mobileFilterWindows){
          mobileFilterWindows.forEach(filterWindow => {
            filterWindow.classList.remove('opened');
          });
        }
      });
    });
  }

  //------------------END SAVE AND CLEAR BUTTONS LOGIC----------------------

  const seeMoreDescription = document.getElementById("seeMoreDescription");
  if (seeMoreDescription) {
    const mobileLocationDescription = document.getElementById("mobileLocationDescription");
    if (mobileLocationDescription) {
      seeMoreDescription.addEventListener("click", function () {
        if (mobileLocationDescription.classList.contains("hidden")) {
          seeMoreDescription.textContent = seeMoreDescription.dataset.seeLess;
        }
        else {
          seeMoreDescription.textContent = seeMoreDescription.dataset.seeMore;
        }

        mobileLocationDescription.classList.toggle("hidden");
      });
    }
  }

  const toggleMobileFilterBarButton = document.getElementById('toggle-mobile-filters-bar');
  const mobileFiltersBar = document.getElementById('mobile-filters-bar');
  const mapControls = document.querySelectorAll('.map-control');
  const listLayout = document.getElementById('listLayout');
  if(toggleMobileFilterBarButton && mobileFiltersBar && mapControls && listLayout){
    toggleMobileFilterBarButton.addEventListener('click', () => {
      mobileFiltersBar.classList.toggle('hidden');

      mapControls.forEach(mapControl => {
        if(mapControl.classList.contains('margin-filters-bar')){
          mapControl.classList.remove('margin-filters-bar');
          mapControl.classList.add('margin-no-filters-bar');
        }
        else{
          mapControl.classList.remove('margin-no-filters-bar');
          mapControl.classList.add('margin-filters-bar');
        }
      });

      if(listLayout.classList.contains('pt-12')){
        listLayout.classList.remove('pt-12');
        listLayout.classList.add('pt-0');
      }
      else{
        listLayout.classList.remove('pt-0');
        listLayout.classList.add('pt-12');
      }
    });
  }
}

//MAP ON/OFF
if(search){
  var initialResizeNeeded = search.classList.contains("initialListMode") ? false : true;
}

const initToggleMap = () => {
  const togglesLayout = document.querySelectorAll(".toggleLayout");
  if (togglesLayout) {
    const header = document.getElementById("navbar-main");
    togglesLayout.forEach(function (toggleLayout) {
      toggleLayout.addEventListener("click", function () {
        const mapLayout = document.getElementById("mapLayout");
        const listLayout = document.getElementById("listLayout");

        if (toggleLayout.classList.contains("mobile-toggle")) {
          if (mapLayout && listLayout) {
            mapLayout.classList.toggle("hidden");
            listLayout.classList.toggle("hidden");

            if(header){
              header.classList.toggle("hidden");
            }

            search.classList.toggle("mobileMapShown");
          }

          const span = toggleLayout.querySelector("span");
          if (span) {
            let text = "";
            // const icon = toggleLayout.querySelector("i");
            if (mapLayout.classList.contains("hidden")) {
              //Showing List of experiences
              text = toggleLayout.dataset.showMap;
              // icon.classList.remove("icon-filters");
              // icon.classList.add("icon-location");
            }
            else {
              //Showing Map
              text = toggleLayout.dataset.showList;
              // icon.classList.remove("icon-location");
              // icon.classList.add("icon-filters");

              let onMobile = window.matchMedia("(max-width: 640px)").matches;
              if(onMobile){
                window.setTimeout(function(){
                  map.resize();
                }, 100);
              }
            }
            span.textContent = text;
          }
        }
        else {
          // mapLayout.classList.toggle("hidden");
          // mapLayout.classList.toggle("md:block");
          if (search) {
            search.classList.toggle("mapCollapsed");
            if(!initialResizeNeeded){
              window.dispatchEvent(new Event('resize'));
              initialResizeNeeded = true;
            }

            //TODO Find a better way (doing this because of glide)
            // setTimeout(function(){
            //   window.dispatchEvent(new Event('resize'));
            // }, 500);
          }
        }
      });
    });
  }
}

//Init maplibre map
var map, algolia = null;
var mapIsFlying = false;
window.mapIsFlying = false;
const initMap = () => {
  if (typeof maplibregl !== "undefined") {
    maplibregl.accessToken = 'pk.eyJ1Ijoid2luYWxpc3QiLCJhIjoiY2p0azd3b2Q5MTQzMjN5bzZidmU5cDF6biJ9.65pAPF4tbn5Geqg7JhvCFQ';

    if (!document.getElementById('map')) {
      return false;
    }

    map = new maplibregl.Map({
      name: 'Winalist',
      container: 'map',
      style: mapTilesStyle,
      zoom: mapContainer.dataset.zoom ? mapContainer.dataset.zoom : 12,
      center: [mapContainer.dataset.lng, mapContainer.dataset.lat]
    });

    //set as a window property so it is accessible from other scripts
    window.map = map;

    map.scrollZoom.disable();

    algolia = getAlgoliaClient();
    const searchOnMove = document.getElementById("searchOnMove");
    const triggerSearchOnClick = document.getElementById("triggerSearch");

    //Proceeds to center the map to the position of the user when map is loaded and comes from the search bar and clicked "around me"
    map.on("load", function () {
      if (mapContainer.dataset.aroundMe && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (myPosition) {
          let lat = myPosition.coords.latitude;
          let lng = myPosition.coords.longitude;

          mapIsFlying = true;
          map.flyTo({
            center: [lng, lat]
          });
        });
      }
    });

    map.on("dragend", function () {
      if (searchOnMove && searchOnMove.checked) {
        debouncedPerformSearch(algolia, map);
      }
      else if (searchOnMove && triggerSearchOnClick && triggerSearchOnClick.classList.contains("hidden")) {
      //   searchOnMove.parentNode.classList.toggle("hidden");
        triggerSearchOnClick.classList.toggle("hidden");
      }
    });

    map.on("zoomend", function () {
      if (/*!mapIsFlying && !window.mapIsFlying && */searchOnMove && searchOnMove.checked) {
        debouncedPerformSearch(algolia, map);
      }
      else if (searchOnMove && triggerSearchOnClick && triggerSearchOnClick.classList.contains("hidden")) {
      //   searchOnMove.parentNode.classList.toggle("hidden");
        triggerSearchOnClick.classList.toggle("hidden");
      }
    });

    map.on('moveend', function () {
      if (mapIsFlying || window.mapIsFlying) {
        map.fire("flyend");
      }
    });

    map.on('flyend', function () {
      mapIsFlying = false;
      window.mapIsFlying = false;
      debouncedPerformSearch(algolia, map);
    });

    map.on('click', function () {
      removeMarkerHighlight();
    });

    if (triggerSearchOnClick && searchOnMove) {
      triggerSearchOnClick.addEventListener("click", function () {
        triggerSearchOnClick.classList.toggle("hidden");
        // searchOnMove.parentNode.classList.remove("hidden");

        debouncedPerformSearch(algolia, map);
      });
    }

    const zoomIn = document.getElementById("zoomIn");
    const zoomOut = document.getElementById("zoomOut");
    if (zoomIn && zoomOut) {
      zoomIn.addEventListener("click", function () {
        map.zoomIn();
      });
      zoomOut.addEventListener("click", function () {
        map.zoomOut();
      });
    }

    const closeNotification = document.getElementById("closeNotification");
    if (closeNotification) {
      const closeNotif = (notificationElement) => {
        notificationElement.remove();

        if (mobilePopups) {
          mobilePopups.classList.remove("mb-48");
          mobilePopups.classList.add("mb-24");
        }
      }

      closeNotification.addEventListener("click", function () {
        closeNotif(closeNotification);
      });

      //closes the notification after 1mn
      window.setTimeout(() => {
        closeNotif(closeNotification);
      }, 60000)
    }

    // const biggerZoom = document.getElementById('biggerZoom');
    // if(biggerZoom){
    //   biggerZoom.addEventListener('click', () => {
    //     map.setZoom(map.getZoom() - 2);
    //     debouncedPerformSearch(algolia, map);
    //   });
    // }

    //if there are experiences available from backend and not algolia
    let experiencesFromBackEnd = document.getElementById('experiences-data');
    if(experiencesFromBackEnd){
      experiencesFromBackEnd = JSON.parse(experiencesFromBackEnd.textContent);
      searchDone(null, experiencesFromBackEnd);
    }
    else{
      debouncedPerformSearch(algolia, map);
    }
  }
};

const goToSlideIndex = (experienceObjectID) => {
  const slide = document.querySelector("li.glide__slide." + experienceObjectID + ":not(.glide__slide--clone)");
  if (slide && currentGlide) {
    setTimeout(function () {
        currentGlide.go("=" + slide.dataset.index);
    }, 200);
  }
}

//Removes popup from experiences when the map is clicked
//TODO > Use the function in map-utils
const removeMarkerHighlight = () => {
  const markerHighlighted = document.querySelector(".marker.highlighted");
  if (markerHighlighted) {
    markerHighlighted.classList.toggle("highlighted");
  }
}

//Get algolia index to perform actions with
const getAlgoliaClient = () => {
  const env = body.dataset.env;
  const lang = body.dataset.lang.substr(0, 2);

  let prefix = '';
  if(env === 'localhost' || env == 'staging'){
    prefix = 'localhost_';
  }
  let experiences_index = prefix + 'experiences_' + lang;

  const client = algoliasearch('AK7I6BLE3J', '6b23703cf5bc843f0015aa31634bdeef');
  return client.initIndex(experiences_index);
}

const debouncedPerformSearch = debounced(100, function (algolia, map) {
  let onMobile = window.matchMedia("(max-width: 640px)").matches;

  //if filters are still opened, there's no reason to perform a search yet
  if(!onMobile || (onMobile && !filters.classList.contains('opened'))){
    performSearch(algolia, map);
  }
});

var oldParams = null;
var oldDateSelected = null;
//Perform the search through algolia
const performSearch = (algolia, map) => {
  let filters = getActiveFilters();
  let params = {
    query: '',
    hitsPerPage: 250,
    attributesToRetrieve: '*',
    responseFields: '*',
    numericFilters: filters.numericFilters,
    facetFilters: filters.facetFilters
  };

  let pos = map.getCenter();
  params.aroundLatLng = pos.lat + "," + pos.lng;
  let bounds = map.getBounds();
  params.aroundRadius = getMapRadius(bounds._ne, bounds._sw);

  //make sure that we fetch only b2b experiences if user is B2B
  params.numericFilters.push(`only_b2b_can_see = ${document.body.dataset.btob === 'true' ? '1' : '0'}`);

  //check if params are different from the last search
  //if so, perform a new search
  if(JSON.stringify(oldParams) !== JSON.stringify(params) || oldDateSelected != currentDateSelected){
    oldParams = params;
    oldDateSelected = currentDateSelected;

    //Trigger loading overlay
    if(loadingOverlay){
      loadingOverlay.classList.remove('hidden');
    }

    //perform search
    //get experiences found with experiences.hits
    algolia.search(params, searchDone);
  }

  //Hide Region Search Description if another search is done after page loading
  if (locationSearchDone) {
    const locationDescription = document.getElementById("locationDescription");
    if (locationDescription) {
      locationDescription.remove();
    }
  }
}

const searchDone = (err, experiences) => {
  if (err) throw err;
  if(currentDateSelected !== null){ //if user chose a date filter
    checkAvailability(experiences.hits); //we check if every experience is actually available (has at least one timeslot opened at the specified date)
  }

  updateExperiencesList(experiences.hits, map); //updates the experiences list
  updateMarkersOnMap(experiences.hits, map); //updates markers on map

  window.scrollTo(0, 0); //make sure we scroll full top when a new search is triggered

  if(loadingOverlay) loadingOverlay.classList.add('hidden');
}


//we check if every experience is actually available (has at least one timeslot opened at the specified date) - called when a search is triggered with a date filter
const checkAvailability = (experiences) => {
  let experience_ids = [];
  experiences.forEach(function(experience){
    experience_ids.push(experience.id);
  });

  let month = '' + (currentDateSelected.getMonth() + 1);
  let day = '' + currentDateSelected.getDate();
  if (month.length < 2){
    month = '0' + month;
  }
  if (day.length < 2){
    day = '0' + day;
  }
  let currentDateSelectedFormatted = [currentDateSelected.getFullYear(), month, day].join('-');

  let formData = new FormData();
  formData.append('date_from', currentDateSelectedFormatted);
  formData.append('experience_ids', JSON.stringify(experience_ids));

  const morning = document.querySelector("input[data-algolia-attribute='morning']");
  const afternoon = document.querySelector("input[data-algolia-attribute='afternoon']");
  if(morning && afternoon){
    checkMorningAndAfternoon(morning, afternoon);
    formData.append('morning', isMorning);
    formData.append('afternoon', isAfternoon);
  }

  const adults = document.getElementById("number-adults");
  const children = document.getElementById("number-children");
  if(adults && children){
    formData.append('spots', Number(adults.value) + Number(children.value));
  }

  let languagesActive = document.querySelectorAll("#filters #languages .filter:checked");
  let langs_ids = [];
  if (languagesActive) {
    languagesActive.forEach(function (language) {
      langs_ids.push(language.dataset.id);
    });

    formData.append('langs_ids', JSON.stringify(langs_ids));
  }

  ajax(search.dataset.filterDate, function(data){
    let i = experiences.length;
    while (i--) {
        if (data.experiences_available.indexOf(experiences[i].id) === -1) {
          experiences.splice(i, 1);
        }
    }
  }, 'POST', formData, {
    "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content
  }, false, true);
}

//In case it is a B2B account and if there is a limitation on the experiences that are allowed to see/book, we want to display only the experiences in the wishlist of the current user
// const removeExperiencesNotInWishlist = (experiences) => {
//   let i = experiences.length;
//   while (i--) {
//       if (wishlist.indexOf(experiences[i].id) === -1) {
//         experiences.splice(i, 1);
//       }
//   }
// }

//Calculate distance in meters from top right to bottom left of the map
//TODO > Use getMapRadius from utils.js
const getMapRadius = (pointA, pointB) => {
  let R = 6371e3;
  let lat1 = pointA.lat;
  let lat2 = pointB.lat;
  let lon1 = -pointA.lng;
  let lon2 = -pointB.lng;

  let φ1 = toRadians(lat1);
  let φ2 = toRadians(lat2);
  let Δφ = toRadians((lat2 - lat1));
  let Δλ = toRadians((lon2 - lon1));

  let a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) *
    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let distance = R * c;

  return parseInt(distance / 2); //Divide by 2 for radius from map center
}

//TODO > See above
const toRadians = (value) => {
  return value * Math.PI / 180;
}

const updateExperiencesList = (experiences, map) => {
  let html = "";
  experiences.forEach(function (experience) {
    let booking_auto = "";
    if (experience.booking_auto) {
      let instantBookingTrad = container.dataset.bookingAuto;
      booking_auto = `<span class="uppercase text-xs mt-1">
                        <i class="icon icon-bolt text-red mr-1"></i>
                        ${instantBookingTrad}
                      </span>`;
    }

    let pictures = ``;
    pictures += `<img class="twic h-full w-full object-cover rounded-l"
                      alt="${experience.name}"
                      draggable="false"
                      src="${experience.cover_cdn_url}/resize=2p"
                      data-src="${experience.cover_cdn_path}"
                      data-src-transform="cover">`;

    let priceFormat;
    let rawPriceFormat;
    if(experience.price > 0){
      if(experience.host.currency_iso != currencyInfos.iso)
        var amount = Math.ceil(experience.price_in_euros * currencyInfos.rate);
      else
        var amount = experience.price_in_euros * currencyInfos.rate;

      let price = new Intl.NumberFormat(currencyInfos.locale, { style: 'currency', currency: currencyInfos.iso }).format(amount);
      priceFormat = container.dataset.from.replace("{0}", " <span class='text-red md:text-black md:font-semibold'>" + price + "</span> ");

      rawPriceFormat = container.dataset.from.replace("{0}", price);
    } else {
      priceFormat = "<span class='text-red md:text-black md:font-semibold'>" + container.dataset.free + "</span>";
      rawPriceFormat = container.dataset.free;
    }

    let average = ``;
    if (experience.review) {
      average += `<span class="rounded border uppercase text-xs px-2 py-1 mr-2">
                    <i class="icon icon-star-alt text-yellow -mt-1"></i>
                    <span class="font-semibold">${Math.round(experience.review * 10) / 10}</span>
                    <span class="text-muted"> (${experience.nb_reviews})</span>
                  </span>`
      ;
    }

    let instant = ``;
    if (experience.booking_auto) {
      instant += `<span class="rounded border uppercase text-xs px-2 py-1">
                    <i class="icon icon-bolt text-red -mt-1"></i>
                    ${container.dataset.bookingAuto}
                  </span>`
      ;
    }

    let wishes = JSON.parse(document.body.dataset.wishes);
    let experiencesInWishlist =
          wishes?.experiencesId
            ? wishes.experiencesId
            : [];

    // var in body, search.twig
    let urlToggleWish = document.body.dataset.urlToggleLike;
    let urlContentnModalWish = document.body.dataset.urlContentModalWish;

    // Manage wishlist
    let inWishlist = experiencesInWishlist.includes(experience.id);
    let wish = `
    <button data-wishlist
            data-wishlist-active
            ${connected || "data-not-connected"}
            ${inWishlist ? "data-delete" : ""}
            data-model="Experience" data-model-id="${experience.id}"
            data-url="${urlToggleWish}"
            data-url-content-modal="${urlContentnModalWish}"
            class="btn-wishlist z-30 absolute rounded-full bg-white right-0 top-0 mt-4 mr-4 text-center py-1 w-10 h-10 text-black text-base">
        <i class="icon z-30 relative ${inWishlist ? "icon-heart-filled text-red" : "icon-heart"} font-semibold"></i>
    </button>
    `;

    let tags = '';
    if(experience.hasOwnProperty('tags_name') && experience.tags_name.length > 0){
      tags = `<span> • ${experience.tags_name[0]}</span>`;

      if(experience.tags_name.length > 1){
        tags += `<span> • ${experience.tags_name[1]}</span>`;
      }

      if(experience.tags_name.length > 2){
        let nbOfTagsLeft = experience.tags_name.length - 2;
        let otherTranslation = nbOfTagsLeft === 1 ? container.dataset.otherTag : container.dataset.otherTags;
        tags += `<span> • ${otherTranslation.replace('{0}', nbOfTagsLeft)}</span>`;
      }
    }

    // <img src="${experience.host.media}" alt="${experience.host.name}" class="w-6 h-6 rounded-full inline-block hostImg">
    // <img src="${experience.host.media}" alt="${experience.host.name}" class="w-8 h-8 object-contain rounded-full mr-1 hostImg">

    if(window.innerWidth < 450){
      if(experience.name !== experience.name.slice(0, 35)){
        experience.name = experience.name.slice(0, 35) + "...";
      }
    }
    else if(window.innerWidth >= 450 && window.innerWidth <= 1280){
      if(experience.name !== experience.name.slice(0, 50)){
        experience.name = experience.name.slice(0, 50) + "...";
      }
    }

    html += `<article class="card searchExperience w-full flex flex-col md:flex-row bg-transparent md:border md:border-gray-300 hover:border-gray-500 mb-8 md:mb-4" data-lat="${experience._geoloc.lat}" data-lng="${experience._geoloc.lng}" data-object-id="${experience.objectID}">
                <a href="${experience.url + utm}" class="from-list" target="${container.dataset.target}" title="${experience.name}">${experience.name}</a>
                <div class="w-full md:w-3/5 h-64 md:h-auto relative picture overflow-hidden">
                    ${wish}
                    ${pictures}
                    <div class="overlay rounded-l"></div>
                    <div class="absolute bottom-0 left-0 ml-1 mb-1 p-2 text-white text-right md:hidden showOnListLayout">
                      <div class="flex justify-end items-center">
                          <a href="${experience.host.url + utm}" target="${container.dataset.target}"
                              class="flex items-center ml-1 text-base md:text-xs text-white relative z-20 from-list">
                            <img class="from-list w-8 h-8 rounded-full inline-block hostImg bg-white object-contain mr-2" alt="${experience.host.name}" draggable="false" src="${experience.host.brand_cdn_url}/contain=60x60"/>
                            <span class="font-semibold from-list">${experience.host.name}</span>
                          </a>
                      </div>
                    </div>
                </div>
                <div class="w-full md:w-auto flex flex-col justify-center md:p-2 md:pl-4 mt-2 md:mt-0 description">
                  <div class="items-center hidden md:flex md:flex-wrap">
                    <span class="inline-block badge badge-champagnelight text-center rounded mr-2 mt-1 mb-1">${experience.activityLevelOneName}</span>
                    <span class="md:hidden mt-1 mb-1">${average}</span>
                    <span class="md:hidden mt-1 mb-1">${instant}</span>
                    <div class="hidden md:block mt-1 mb-1 hideOnListLayout">
                      ${average}
                      ${instant}
                    </div>
                  </div>
                  <div class="mb-1 flex items-center md:hidden">
                    ${experience.booking_auto ? `
                      <div class="bg-blue flex justify-center items-center w-4 h-4 rounded-full mr-2">
                        <i class="icon icon-bolt text-white text-xs bolt-icon"></i>
                      </div>`
                      : ''
                    }
                    <span class="text-xs uppercase text-gray-500 mr-1">${typeof experience.host.region === 'object' ? experience.host.region.name : experience.host.region}</span>
                    <span class="text-gray-500 text-xs mr-1">•</span>
                    <span class="text-xs uppercase text-gray-500 mr-1">${experience.activityLevelOneName}</span>
                    ${experience.review ? `
                      <span class="rounded ml-auto md:ml-0 md:border uppercase text-xs px-2 py-1 md:mr-2">
                        <i class="icon icon-star-alt text-yellow -mt-1"></i>
                        <span class="font-semibold">${Math.round(experience.review * 10) / 10}</span>
                        <span class="text-muted"> (${experience.nb_reviews})</span>
                      </span>`
                    : ''}
                  </div>
                  <div class="mb-1">
                    <h2 class="text-xl font-semibold">${experience.name}</h2>
                  </div>
                  <div class="md:hidden text-gray-500 text-base mb-2">
                    <span>${experience.duration_algolia}</span>
                    ${tags}
                  </div>
                  <div class="md:hidden">
                    <p class="font-semibold bg-gray-100 text-center p-2 text-base rounded-lg">${rawPriceFormat}</p>
                  </div>
                  <div class="mb-1 hidden text-sm text-gray-400 hideOnListLayout contentShort">
                    ${experience.content_short}
                  </div>
                  <div class="mb-1 flex items-center hidden md:flex hideOnListLayout">
                    <img class="w-8 h-8 object-contain rounded-full mr-1 hostImg" alt="${experience.host.name}" draggable="false" src="${experience.host.brand_cdn_url}/contain=60x60"/>
                    <a href="${experience.host.url + utm}" target="${container.dataset.target}" class="from-list text-base text-black relative hover:no-underline z-20 hostUrl">${experience.host.name}</a>
                  </div>
                  <div class="mb-2 flex items-center order-last md:order-none hidden md:block">
                    <span>${priceFormat} • ${experience.duration_algolia}</span>
                  </div>
                </div>
            </article>
          `;
        //   <div class="my-1 flex items-center md:hidden showOnListLayout">
        //   ${average}
        //   ${instant}
        // </div>
  });

  container.innerHTML = html;

  let newExperiences = document.querySelectorAll(".searchExperience");
  if (newExperiences) {
    newExperiences.forEach(function (newExperience) {
      newExperience.addEventListener("mouseenter", function (e) {
        // let lng = e.target.dataset.lng;
        // let lat = e.target.dataset.lat;
        // mapIsFlying = true;
        // map.easeTo({
        //   center: [lng, lat],
        //   // zoom: 13
        // });

        let objectID = e.target.dataset.objectId;
        openPopup(objectID);
      });
    });
  }

  //mount glide for each experience (carousel)
  const glidePictures = document.querySelectorAll(".glide-experience");
  if (glidePictures) {
    glidePictures.forEach(function (glidePicture) {
      let glide = new Glide(glidePicture, {
        perView: 1,
        type: 'carousel'
      });

      glide.mount({ Controls, Breakpoints, Swipe, ArrowDisabler });
    });
  }

  const countExperiencesLocation = document.getElementById("countExperiencesLocation");
  const countExperiences = document.getElementById("countExperiences");
  const locationNotation = document.getElementById("locationNotation");
  const noExperienceWrapper = document.getElementById('noExperienceWrapper');
  if (/*search.dataset.location && */!locationSearchDone) {
    if (countExperiencesLocation/* && experiences.length > 0*/) {
      let location = search.dataset.location;
      // let locationType = search.dataset.locationType;
      let activity = search.dataset.activity;

      if(activity === 'false'){
        var showingExperiencesLocationText = countExperiencesLocation.dataset.showingExperiencesLocation.replace("{0}", experiences.length).replace("{1}", location);
      } else {
          var showingExperiencesLocationText = countExperiencesLocation.dataset.showingExperiencesLocation.replace("{0}", experiences.length).replace("{1}", activity).replace("{2}", location);
      }
      countExperiencesLocation.textContent = experiences.length > 0 ?
      showingExperiencesLocationText : countExperiencesLocation.dataset.noExperiencesLocation.replace("{0}", location);
    } /*else {
      if (locationNotation) {
        locationNotation.remove();
      }
      if(noExperienceWrapper) noExperienceWrapper.classList.remove('hidden');
    }*/

    locationSearchDone = true;
  }
  else {
    if (countExperiences) {
      /*if(experiences.length > 0){
        countExperiences.textContent = countExperiences.dataset.showingExperiences.replace("{0}", experiences.length);
        if(noExperienceWrapper) noExperienceWrapper.classList.add('hidden');
      } else {
        if(noExperienceWrapper) noExperienceWrapper.classList.remove('hidden');
      }*/
      countExperiences.textContent = experiences.length > 0 ? countExperiences.dataset.showingExperiences.replace("{0}", experiences.length) : countExperiences.dataset.noExperiences;
      countExperiences.classList.remove("hidden");
    }
    if (locationNotation) {
      locationNotation.remove();
    }
  }

  Wish.bindWishButtons(); //bind wish buttons to make ajax calls and the experience clicked to the user's wishlist
}

var markersPlaced = [];
var alreadyVisitedMarkers = [];
const mobilePopups = document.getElementById("mobilePopups");
const updateMarkersOnMap = (experiences, map) => {
  //Clears every current markers on map
  Object.values(markersPlaced).forEach(function (marker) {
    marker.remove();
  });

  //Regroup experiences by geoloc (lat, lng)
  let experiencesSortedByGeoLoc = groupBy(experiences, function (experience) {
    if (experience._geoloc.lat && experience._geoloc.lng) {
      return [experience._geoloc.lat, experience._geoloc.lng];
    }
  });

  let onMobile = window.matchMedia("(max-width: 640px)").matches;
  if (mobilePopups) {
    mobilePopups.innerHTML = ``;
    mobilePopups.classList.add("hidden");
    mapContainer.addEventListener("click", function () {
      mobilePopups.innerHTML = ``;
      mobilePopups.classList.add("hidden");
    });
  }

  experiencesSortedByGeoLoc.forEach(function (experiences) {
    let marker = document.createElement('div');
    let experience = experiences[0];

    //Single experience at this geolocation
    if (experiences.length === 1) {
      marker.className = 'marker single-marker relative';
      if (alreadyVisitedMarkers.indexOf(experience.objectID) !== -1) {
        marker.className += " alreadyVisited";
      }

      if(experience.host.currency_iso != currencyInfos.iso)
        var amount = Math.ceil(experience.price_in_euros * currencyInfos.rate);
      else
        var amount = experience.price_in_euros * currencyInfos.rate;

      //format the experience price with the current currency
      let formattedPrice = new Intl.NumberFormat(currencyInfos.locale, { style: 'currency', currency: currencyInfos.iso, minimumFractionDigits: 0 }).format(amount);
      marker.textContent = formattedPrice;
      if (experience.booking_auto) { //if experience is in booking_auto mode, add the booking auto icon
        let icon = buildBookingAutoIcon();
        marker.appendChild(icon);
      }

      // if (wishlist.indexOf(parseInt(experience.objectID.split("_")[1])) !== -1) { //if the experience is in the user's wishlist, append the heart icon to the marker
      //   let heart = document.createElement("i");
      //   heart.className = "icon icon-heart-filled heart text-red text-xs font-semibold ml-2";
      //   marker.appendChild(heart);
      // }
    }

    //Multiple experiences at this geolocation (cluster)
    else if (experiences.length > 1) {
      let experiencesObjectIds = [];
      let atLeastOneBookingAuto = false;
      experiences.forEach(function (experience) {
        experiencesObjectIds.push(experience.objectID);

        if (experience.booking_auto) {
          atLeastOneBookingAuto = true;
        }
      });

      marker.className = 'marker cluster-markers ' + experiencesObjectIds.join(' ');
      marker.dataset.linkExperience = experience.objectID;
      marker.textContent = experiences.length;

      if (atLeastOneBookingAuto) { //if at least one experience in the cluster is in booking_auto mode, add the booking auto icon
        let icon = buildBookingAutoIcon();
        marker.appendChild(icon);
      }
    }

    marker.addEventListener('click', function () {
      //setTimeout is used to make sure this is done after map click event (which removes highlighted markers)
      setTimeout(function () {
        marker.classList.toggle("highlighted");

        if (experiences.length === 1) {
          marker.classList.add("alreadyVisited");
          if (alreadyVisitedMarkers.indexOf(experience.objectID) === -1) { //add the experience to already visited markers so that at the next search the marker will be "already visited" with the style that goes with
            alreadyVisitedMarkers.push(experience.objectID);
          }
        }
      }, 100);
    });

    if (onMobile && mobilePopups) { //if user is on mobile
      marker.addEventListener("click", function () {
        setTimeout(function () {
          mobilePopups.innerHTML = buildMobilePopup(experiences);
          mobilePopups.classList.remove("hidden");
        }, 100);
      });

      markersPlaced[experience.objectID] = new maplibregl.Marker({element: marker})
        .setLngLat([experience._geoloc.lng, experience._geoloc.lat])
        .addTo(map);
    }
    else { //if user is on tablet/desktop
      let popupOptions = {
        offset: 30,
        closeButton: false
      };
      let popup = new maplibregl.Popup(popupOptions).setHTML(buildPopupHTML(experiences));
      popup.on("open", function () {
        if (experiences.length > 1) {
          initializeGlider();
        }
      });

      markersPlaced[experience.objectID] = new maplibregl.Marker({element: marker})
        .setLngLat([experience._geoloc.lng, experience._geoloc.lat])
        .setPopup(popup)
        .addTo(map);
    }
  });
}

//build the popup (that appears when a marker is clicked) - FOR DESKTOP
//TODO > refact with the function in map-utils
const buildPopupHTML = (experiences) => {
  let html = "";
  if (experiences.length > 1) { //if there are multiple experiences at the same spot (lat - lng), we build a carousel (with glide) with the experiences
    html = `
    <div class="glide arrows_in glide-popup opacity-0" >
        <div class="glide__track" data-glide-el="track">
            <ul class="glide__slides">
    `;

    for (let i = 0; i < experiences.length; i++) {
      let experience = experiences[i];

      html += buildPopupBody(experience, true, i);
    }

    html += `
        </ul>
      </div>
      <div class="glide__arrows" data-glide-el="controls">
          <button class="glide__arrow glide__arrow--left text-black bg-white rounded-full border w-10 h-10 text-center" data-glide-dir="<" aria-label="Go back to previous pictures" title="Go back to previous pictures"><i class="icon icon-caret-left"></i></button>
          <button class="glide__arrow glide__arrow--right text-black bg-white rounded-full border w-10 h-10 text-center" data-glide-dir=">" aria-label="Go to next pictures" title="Go to next pictures"><i class="icon icon-caret-right"></i></button>
      </div>
    </div>
    <div class="gallery flex overflow-auto">
    `;

    let width = "16.6%";
    if(experiences.length <= 6){ //make sure there are only 6 experiences thumbnails maximum on the same row
      width = 100 / experiences.length + "%";
    }
    for (let i = 0; i < experiences.length; i++) {
      html += `
        <button class="galleryItem flex-shrink-0 p-2 outline-none border-t-2 ${i === 0 ? 'active' : ''} flex justify-center" style="width:${width}" data-index="${i}">
            <img class="h-10 w-10 rounded-lg object-cover" alt="${experiences[i].name}" draggable="false" src="${experiences[i].cover_cdn_url}/cover=70x70"/>
        </button>
      `;
    }

    html += `
    </div>
    `;

  }
  else { //if there's only one experience at the spot
    let experience = experiences[0];
    html += buildPopupBody(experience, false, 0);
  }

  return html;
}


//build the popup body (with all experience infos)
const buildPopupBody = (experience, isSlider, index) => {
  let components = getExperienceComponents(experience, currencyInfos);

  let html = isSlider ? `<li class="glide__slide ${experience.objectID}" data-index=${index}>` : ``; //if it's a carousel (see above in buildPopupHTML)
  html += `
    <div class="flex flex-col rounded popup">
      <a href="${experience.url + utm}" target="${container.dataset.target}" class="from-map block h-56 w-full bg-transparent rounded-t overflow-hidden">
        <img class="from-map twic h-full w-full object-cover" alt="${experience.name}" draggable="false" src="${experience.cover_cdn_url}/resize=2p" data-src="${experience.cover_cdn_path}" data-src-transform="cover"/>
      </a>
      <div class="p-4 relative">
        <div class="flex flex-wrap items-center mb-2">
          <span class="badge badge-champagnelight text-gray-700 mr-2">${experience.activityLevelOneName}</span>
          ${components.reviews}
          <span class="text-xs text-gray-500 ${experience.average_review ? 'ml-3' : ''}"><i class="icon icon-time"></i> ${experience.duration_algolia}</span>
        </div>
        <a href="${experience.url + utm}" target="${container.dataset.target}" class="from-map mt-1 font-semibold text-base text-black hover:no-underline">${experience.name}</a>
        <p class="mt-2 text-sm">${components.priceFormat}</p>
        <a href="${experience.host.url + utm}" target="${container.dataset.target}" class="from-map text-gray-700 text-xs relative z-50">${components.byTrad}</a>
        ${components.booking_auto}
      </div>
    </div>
  `;

  if (isSlider) {
    html += `</li>`;
  }

  return html;
}

//TODO > use the function in map-utils
const buildMobilePopup = (experiences) => {
  let html = "";
  if (mobilePopups) {
    if (experiences.length > 1) {
      experiences.forEach(function (experience) {
        let components = getExperienceComponents(experience);
        html += buildMobilePopupExperience(experience, components, true);
      });
    }
    else {
      let components = getExperienceComponents(experiences[0]);
      html += buildMobilePopupExperience(experiences[0], components, false);
    }
  }

  return html;
}

//build the popup (that appears when a marker is clicked) - FOR MOBILE
//TODO > use the function in map-utils
const buildMobilePopupExperience = (experience, components, isCluster) => {
  let onMobile = window.matchMedia("(max-width: 640px)").matches;

  let html = `
    <div class="mobilePopup w-11/12 ${isCluster ? "mr-2" : "mx-auto"} shadow-xl inline-flex rounded bg-white whitespace-normal h-full">
      <div class="w-5/12 bg-transparent p-3">
        <a href="${experience.url + utm}" target="${container.dataset.target}" class="from-map">
          <img class="from-map twic h-full w-full object-cover rounded" alt="${experience.name}" draggable="false" src="${experience.cover_cdn_url}/resize=2p" data-src="${experience.cover_cdn_path}" data-src-transform="cover"/>
        </a>
      </div>
      <div class="p-3 w-7/12 flex flex-col justify-center relative">
        <div class="flex flex-wrap items-center">
          <span class="badge badge-champagnelight text-gray-700 mr-2 mt-1">${experience.activityLevelOneName}</span>
          ${components.reviews}
          <span class="text-xs text-gray-500 ${experience.average_review ? 'ml-3' : ''} ${onMobile ? 'mt-1' : ''}">
            <i class="icon icon-time"></i>
            ${experience.duration_algolia}
          </span>
        </div>
        <a href="${experience.url + utm}" target="${container.dataset.target}" class="from-map mt-1 font-semibold text-base text-black hover:no-underline overflow-hidden">${experience.name}</a>
        <p class="mt-2 text-sm">${components.priceFormat}</p>
        <a href="${experience.host.url + utm}" target="${container.dataset.target}" class="from-map text-gray-700 text-xs relative z-50">${components.byTrad}</a>
        ${components.booking_auto}
      </div>
    </div>
  `;

  return html;
}

//get experience components (like formatted price, booking auto div, reviews div)
const getExperienceComponents = (experience) => {
  let priceFormat;
  if(experience.host.currency_iso != currencyInfos.iso)
    var amount = Math.ceil(experience.price_in_euros * currencyInfos.rate);
  else
    var amount = experience.price_in_euros * currencyInfos.rate;

  var price = new Intl.NumberFormat(currencyInfos.locale, { style: 'currency', currency: currencyInfos.iso }).format(amount);
  if(experience.price > 0){
    priceFormat = mapContainer.dataset.from.replace("{0}", price);
  } else {
    priceFormat = container.dataset.free;
  }
  let byTrad = mapContainer.dataset.by.replace("{0}", experience.host.name);
  // let onMobile = window.matchMedia("(max-width: 640px)").matches;

  let booking_auto = ``;
  if (experience.booking_auto) {
    booking_auto =
      `
      <div class="bg-blue absolute right-0 bottom-0 mr-2 mb-2 flex justify-center items-center w-5 h-5 rounded-full">
        <i class="icon icon-bolt text-white text-xs"></i>
      </div>
    `;
  }

  let reviews = ``;
  if (experience.nb_reviews > 0) {
    reviews = `
    <div class="rounded border uppercase text-xs px-2 mr-2 mt-1">
      <i class="icon icon-star-alt text-yellow -mt-1"></i>
      <span class="font-semibold">${experience.review}</span>
      <span class="text-muted"> (${experience.nb_reviews})</span>
    </div>
    `;
  }

  return {
    price: price,
    priceFormat: priceFormat,
    byTrad: byTrad,
    booking_auto: booking_auto,
    reviews: reviews
  };
}

//trigger the marker popup corresponding to the hovered experience in the list
const openPopup = (experienceObjectID) => {
  let marker = markersPlaced[experienceObjectID];
  let popup;
  if (!marker) {
    const markerSpot = document.querySelector("div.marker." + experienceObjectID);
    if (markerSpot) {
      marker = markersPlaced[markerSpot.dataset.linkExperience];
    }
  }

  if (marker) {
    popup = marker.getPopup();
    removeMarkerHighlight();
    marker._element.classList.toggle("highlighted");
  }

  //Close every popups
  Object.values(markersPlaced).forEach(function (markerTemp) {
    let markerPopup = markerTemp.getPopup();
    if (markerPopup && markerPopup.isOpen()) {
      markerTemp.togglePopup();
    }
  });

  if (marker && popup && !popup.isOpen()) {
    marker.togglePopup();
    goToSlideIndex(experienceObjectID);

    // marker._element.classList.add("alreadyVisited");
    // if(alreadyVisitedMarkers.indexOf(experienceObjectID) === -1){
    //   alreadyVisitedMarkers.push(experienceObjectID);
    // }
  }
}

//TODO > Refact with the function in map-utils.js
var currentGlide;
const initializeGlider = () => {
  window.setTimeout(function(){
    const glideEl = document.querySelector(".glide-popup");
    if (glideEl) {
      let glide = new Glide(glideEl, {
        perView: 1,
        type: 'carousel',
        rewind: false,
        bound: true,
      });

      glide.on('build.after', () => {
        if (glideEl.classList.contains("opacity-0")) {
          glideEl.classList.toggle("opacity-0");
          glideEl.classList.toggle("opacity-100");
        }

        const galleryItems = document.querySelectorAll(".galleryItem");
        if(galleryItems){
          galleryItems.forEach(function(item){
            item.addEventListener("click", function(){
              glide.go("=" + item.dataset.index);
            });
          })
        }
      });

      glide.on("run.after", function () {
        let currentActiveExp = document.querySelector(".galleryItem.active");
        if (currentActiveExp) {
          currentActiveExp.classList.toggle("active");
        }

        let glideIndex = glide.index;
        const wrapper = document.querySelector('.gallery');
        if(wrapper){
          wrapper.scrollTo({
            top: 0,
            left: glideIndex < 4 ? 0 : 50 * glideIndex, //every gallery item is approximatively 50px wide
            behavior: 'smooth'
          })
        }

        let gallery = document.querySelectorAll(".gallery .galleryItem");
        if (gallery && gallery[glideIndex]) {
          gallery[glideIndex].classList.toggle("active");
        }
      });

      if (glide && !glideEl.classList.contains("glide--carousel")) {
        glide.mount({ Controls, Breakpoints, Swipe, ArrowDisabler });
        currentGlide = glide;
      }
    }
  }, 200);
};

//builds the div with the booking auto icon
//TODO > refact with the same function in map-utils.js
const buildBookingAutoIcon = () => {
  let bookingAuto = document.createElement('div');
  bookingAuto.className = "booking-auto absolute bg-blue flex justify-center items-center w-5 h-5 rounded-full";

  let icon = document.createElement('i');
  icon.className = "icon icon-bolt text-white text-xs";

  bookingAuto.appendChild(icon);
  return bookingAuto;
}

const initActiveFilters = () => {
  //For INLINE filters
  // const inlinefiltersToCount = document.querySelectorAll(".inlineFilters .btn-filter:not(.inline-filter)");
  const inlinefiltersToCount = document.querySelectorAll(".inlineFilters .filter");
  if (inlinefiltersToCount) {
    inlinefiltersToCount.forEach(function (inlineFilterToCount) {
      inlineFilterToCount.addEventListener("click", function () {
        const filterToCount = inlineFilterToCount.closest(".filterToCount");
        if (filterToCount) {
          setActiveFilter(filterToCount);
        }
      });
    });
  }

  //For MORE filters
  const moreFiltersToCount = document.querySelectorAll(".moreFilters .filter");
  if (moreFiltersToCount) {
    moreFiltersToCount.forEach(function (moreFilterToCount) {
      moreFilterToCount.addEventListener("click", function () {
        const wrapper = moreFilterToCount.parentNode.dataset.setActive;
        if (wrapper) {
          const inlineFilter = document.getElementById(wrapper);
          if (inlineFilter) {
            setActiveFilter(inlineFilter);
          }
          else{
            const inlineFilter = document.querySelector('.' + wrapper);
            if (inlineFilter) {
              setActiveFilter(inlineFilter);
            }
          }
        }
      });
    });
  }

  //IF TAG_ACTIVITY_ID OU ? OU ?
  const filtersToCount = document.querySelectorAll(".filterToCount");
  if (filtersToCount) {
    filtersToCount.forEach(function (filterToCount) {
      setActiveFilter(filterToCount);
    });
  }
}

const setActiveFilter = (wrapper) => {
  // const filtersActive = wrapper.querySelectorAll(".btn-filter.active:not(.inline-filter):not(.noCount)");
  const filtersActive = wrapper.querySelectorAll(".filter:checked:not(.noCount)");
  let nbOfActiveFilters = 0;
  if (filtersActive) {
    nbOfActiveFilters = filtersActive.length;
  }

  if(wrapper.hasAttribute('data-button')){
    var inlineFilterButton = document.getElementById(wrapper.dataset.button);
  }
  else{
    var inlineFilterButton = wrapper.querySelector(".inline-filter");
  }

  if (inlineFilterButton) {
    let initialText = inlineFilterButton.dataset.initialText;
    if (nbOfActiveFilters > 0) {
      inlineFilterButton.textContent = initialText + " • " + nbOfActiveFilters;
      inlineFilterButton.classList.add("active");
    }
    else if (nbOfActiveFilters === 0) {
      inlineFilterButton.textContent = initialText;
      inlineFilterButton.classList.remove("active");
    }
  }
}

const setActiveFiltersFromSession = () => {
  const languagesWrapper = document.querySelector(".languagesWrapper");
  if (languagesWrapper) {
    setActiveFilter(languagesWrapper);
  }
}

const activePersonsText = () => {
  const adults = document.getElementById("number-adults-more");
  const children = document.getElementById("number-children-more");
  const inlinePersons = document.getElementById("inlinePersons");
  if (adults && children && inlinePersons) {
    sessionVars.adults = adults.value;
    sessionVars.children = children.value;

    let text = "";
    if (adults.value > 0) {
      let adultsTrad = inlinePersons.dataset.adults.replace("{0}", adults.value);
      let adultTrad = inlinePersons.dataset.adult;
      text += adults.value > 1 ? adultsTrad : adultTrad;
    }
    if (children.value > 0) {
      if (adults.value > 0) {
        text += ", ";
      }
      let childrenTrad = inlinePersons.dataset.children.replace("{0}", children.value);
      let childTrad = inlinePersons.dataset.child;
      text += children.value > 1 ? childrenTrad : childTrad;
    }

    if (adults.value == 0 && children.value == 0) {
      text = inlinePersons.dataset.noValue;
      inlinePersons.classList.remove("active");
    }
    else {
      inlinePersons.classList.add("active");
    }

    inlinePersons.textContent = text;
  }
}

const initActivePersons = () => {
  const personsButtons = document.querySelectorAll(".personsButton");
  if (personsButtons) {
    personsButtons.forEach(function (personsButton) {
      personsButton.addEventListener("click", function () {
        setTimeout(function () {
          activePersonsText();
        }, 300);
      });
      // personsButton.dispatchEvent(new Event("click"));
    });
  }

  activePersonsText();
}



//---------------------GET FILTERS-------------------------

//get all filters we need to perform the algolia search
const getActiveFilters = () => {
  // let onMobile = window.matchMedia("(max-width: 640px)").matches;

  let params = {};
  params.numericFilters = [];
  params.facetFilters = [];

  // getTimesOfDay(params.numericFilters);
  getInstantBook(params.numericFilters);
  getTypesOfExp(params.facetFilters);
  getLanguages(params.facetFilters);
  getTypesOfHost(params.facetFilters);
  getServices(params.facetFilters);
  getNumberOfPersons(params.numericFilters);
  getPrice(params.numericFilters);
  // if (onMobile) {
  //   getDaysMobile(params.facetFilters);
  // }
  // else {
  //   getDays(params.facetFilters);
  // }
  getVisibility(params.numericFilters);
  getCancellation(params.numericFilters);
  getTagID(params.facetFilters);

  return params;
}

// const getTimesOfDay = (numericFilters) => {
//   let timesOfDayActive = document.querySelectorAll("#filters #timesOfDay .filter:checked");
//   if (timesOfDayActive) {
//     timesOfDayActive.forEach(function (timeOfDay) {
//       let algoliaAttribute = timeOfDay.dataset.algoliaAttribute;
//       if (algoliaAttribute) {
//         numericFilters.push(algoliaAttribute + ' = 1');
//       }
//     });
//   }
// }

const getInstantBook = (numericFilters) => {
  const instantBook = document.getElementById("instantBook");
  if (instantBook && instantBook.checked) {
    numericFilters.push('booking_auto = 1');
  }
}

const getTypesOfExp = (facetFilters) => {
  let typesOfExpArr = [];

  let typesOfExpActive = document.querySelectorAll("#filters #typesOfExp .filter:checked");
  if (typesOfExpActive) {
    typesOfExpActive.forEach(function (typeOfExp) {
      let typeOfExpID = typeOfExp.dataset.id;
      if (typeOfExpID) {
        typesOfExpArr.push('activitys:' + typeOfExpID);
      }
    });
  }

  if (typesOfExpArr.length > 0) {
    facetFilters.push(typesOfExpArr);
  }
}

const getLanguages = (facetFilters) => {
  let languagesArr = [];

  let languagesActive = document.querySelectorAll("#filters #languages .filter:checked");
  if (languagesActive) {
    languagesActive.forEach(function (language) {
      let languageISO = language.dataset.iso;
      if (languageISO) {
        languagesArr.push('langs:' + languageISO);
      }
    });
  }

  if (languagesArr.length > 0) {
    facetFilters.push(languagesArr);
  }
}

const getTypesOfHost = (facetFilters) => {
  let typesOfHost = [];

  let typesOfHostActive = document.querySelectorAll("#filters #typesOfHost .filter:checked");
  if (typesOfHostActive) {
    typesOfHostActive.forEach(function (typeOfHost) {
      let typeOfHostID = typeOfHost.dataset.id;
      if (typeOfHostID) {
        typesOfHost.push('categories:' + typeOfHostID);
      }
    });
  }

  if (typesOfHost.length > 0) {
    facetFilters.push(typesOfHost);
  }
}

const getServices = (facetFilters) => {
  let services = [];

  let servicesActive = document.querySelectorAll("#filters #services .filter:checked");
  if (servicesActive) {
    servicesActive.forEach(function (service) {
      let serviceID = service.dataset.id;
      if (serviceID) {
        services.push('services:' + serviceID);
      }
    });
  }

  if (services.length > 0) {
    facetFilters.push(services);
  }
}

const getNumberOfPersons = (numericFilters) => {
  const adults = document.getElementById("number-adults");
  const children = document.getElementById("number-children");
  let persons = parseInt(adults.value) + parseInt(children.value);

  if (persons > 0) {
    numericFilters.push("booking_min <= " + persons);
    numericFilters.push("booking_max >= " + persons);
  }
}

if(search){
  var minPrice = 0;
  var maxPrice = body.dataset.highestPrice;
}

const getPrice = (numericFilters) => {
  numericFilters.push('price_in_euros >= ' + minPrice);
  numericFilters.push('price_in_euros <= ' + maxPrice);
}

// const getDays = (facetFilters) => {
//   let timeSlots = [];

//   const flatpickrMore = document.getElementById("flatpickr-more");
//   if (flatpickrMore && flatpickrMore.dataset.activeDays) {
//     let activeDays = JSON.parse(flatpickrMore.dataset.activeDays);
//     if (activeDays) {
//       const morning = document.querySelector("input[data-algolia-attribute='morning']");
//       const afternoon = document.querySelector("input[data-algolia-attribute='afternoon']");
//       activeDays.forEach(function (dayOfWeek) {
//         setTimeSlots(timeSlots, morning, afternoon, dayOfWeek);
//       });

//       if (timeSlots.length) {
//         facetFilters.push(timeSlots);
//       }

//       checkMorningAndAfternoon(morning, afternoon);
//     }
//   }
// }

// const getDaysMobile = (facetFilters) => {
//   let timeSlots = [];

//   //Check dataset of mobile flatpickr (if it exists it means that a date is set)
//   const flatpickrMobile = document.getElementById("mobileFlatpickr");
//   if (flatpickrMobile && flatpickrMobile.dataset.activeDays) {
//     let activeDays = JSON.parse(flatpickrMobile.dataset.activeDays);
//     if (activeDays) {
//       const morning = document.querySelector("input[data-algolia-attribute='morning']");
//       const afternoon = document.querySelector("input[data-algolia-attribute='afternoon']");
//       activeDays.forEach(function (dayOfWeek) {
//         setTimeSlots(timeSlots, morning, afternoon, dayOfWeek);
//       });

//       if (timeSlots.length) {
//         facetFilters.push(timeSlots);
//       }

//       checkMorningAndAfternoon(morning, afternoon);
//     }
//   }
//   else {
//     const mobileInlineCalendar = document.getElementById("mobileInlineCalendar");
//     if (mobileInlineCalendar) {
//       const activeDates = mobileInlineCalendar.querySelectorAll(".filter:checked");
//       if (activeDates) {
//         const morning = document.querySelector("input[data-algolia-attribute='morning']");
//         const afternoon = document.querySelector("input[data-algolia-attribute='afternoon']");

//         activeDates.forEach(function (activeDate) {
//           setTimeSlots(timeSlots, morning, afternoon, activeDate.dataset.dayOfWeek);
//         });

//         if (timeSlots.length) {
//           facetFilters.push(timeSlots);
//         }

//         checkMorningAndAfternoon(morning, afternoon);
//       }
//     }
//   }
// }

// const setTimeSlots = (timeSlots, morning, afternoon, dayOfWeek) => {
//   if(dayOfWeek === 0){
//     dayOfWeek = 7;
//   }

//   if ((morning.checked && afternoon.checked) || (!morning.checked && !afternoon.checked)) {
//     timeSlots.push("time_slots:" + dayOfWeek + "ma");
//     timeSlots.push("time_slots:" + dayOfWeek + "m");
//     timeSlots.push("time_slots:" + dayOfWeek + "a");
//   }
//   else {
//     if (morning.checked) {
//       timeSlots.push("time_slots:" + dayOfWeek + "m");
//     }
//     else if (afternoon.checked) {
//       timeSlots.push("time_slots:" + dayOfWeek + "a");
//     }
//   }
// }

const checkMorningAndAfternoon = (morning, afternoon) => {
  isMorning = morning.checked;
  isAfternoon = afternoon.checked;
}

const getCancellation = (numericFilters) => {
  const visibility = document.querySelector("input[name='cancellation']:checked");
  if (visibility && visibility.value === "full_refund_under_24") {
    numericFilters.push("full_refund_under_24 = 1");
  }
}

const getVisibility = (numericFilters) => {
  const visibility = document.querySelector("input[name='more-visibility']:checked");
  if (visibility && visibility.value === "private") {
    numericFilters.push("private = 1");
  }
}

const getTagID = (facetFilters) => {
  const tagID = document.getElementById('tagID');
  if(tagID){
    facetFilters.push(['tags:' + tagID.value]);
  }
}

//---------------------END GET FILTERS---------------------

const initEvents = () => {
  const cancellationOptions = document.querySelectorAll("input[name='cancellation']");
  if(cancellationOptions){
    cancellationOptions.forEach(function(cancellation){
      cancellation.addEventListener("change", function(){
        appendGet('cancellation', cancellation.value, window.location.href);
      });
    });
  }
}

const initAroundMe = () => {
  window.addEventListener('click', (e) => {
    if(e.target.classList.contains('trigger-around-me') || e.target.closest('.trigger-around-me') !== null){
      const isInListLayout = !document.getElementById('listLayout').classList.contains('hidden');

      navigator.geolocation.getCurrentPosition(function (myPosition) {
        let lat = myPosition.coords.latitude;
        let lng = myPosition.coords.longitude;

        mapIsFlying = true;
        let options = {
            center: [lng, lat],
            zoom: 11,
            speed: 2.5
        };

        if(isInListLayout){
          map.jumpTo(options);
        }
        else{
          map.flyTo(options);
        }
      });

      window.searchAutocomplete.autocomplete.close();
    }
  });
  // const aroundMeButtons = document.querySelectorAll('.trigger-around-me');
  // if(aroundMeButtons){
  //   aroundMeButtons.forEach(aroundMeButton => {
  //     aroundMeButton.addEventListener('click', () => {
  //       navigator.geolocation.getCurrentPosition(function (myPosition) {
  //         let lat = myPosition.coords.latitude;
  //         let lng = myPosition.coords.longitude;

  //         mapIsFlying = true;
  //         map.flyTo({
  //           center: [lng, lat],
  //           zoom: 11
  //         });
  //       });
  //     });
  //   });
  // }
}

//To sync persons inputs between inline and more filters
const initPersonsInput = () => {
  const adultsInline = document.getElementById("number-adults");
  const childrenInline = document.getElementById("number-children");
  const adultsMore = document.getElementById("number-adults-more");
  const childrenMore = document.getElementById("number-children-more");

  const adultsInlineInputs = document.querySelectorAll(".adultsInline");
  const childrenInlineInputs = document.querySelectorAll(".childrenInline");
  const adultsMoreInputs = document.querySelectorAll(".adultsMore");
  const childrenMoreInputs = document.querySelectorAll(".childrenMore");
  if (adultsInline && childrenInline && adultsMore && childrenMore) {
    adultsInlineInputs.forEach(function (adultsInlineInput) {
      adultsInlineInput.addEventListener("click", function () {
        //TODO find better way
        setTimeout(function () {
          adultsMore.value = adultsInline.value;
          sessionVars.adults = adultsInline.value;
          updateValueDisplayed();

          // debouncedSessionUpdate();
        }, 200);
      });
    });

    childrenInlineInputs.forEach(function (childrenInlineInput) {
      childrenInlineInput.addEventListener("click", function () {
        setTimeout(function () {
          childrenMore.value = childrenInline.value;
          sessionVars.children = childrenInline.value;
          updateValueDisplayed();

          // debouncedSessionUpdate();
        }, 200);
      });
    });

    adultsMoreInputs.forEach(function (adultsMoreInput) {
      adultsMoreInput.addEventListener("click", function () {
        setTimeout(function () {
          adultsInline.value = adultsMore.value;
          sessionVars.adults = adultsMore.value;
          updateValueDisplayed();

          // debouncedSessionUpdate();
        }, 200);
      });
    });

    childrenMoreInputs.forEach(function (childrenMoreInput) {
      childrenMoreInput.addEventListener("click", function () {
        setTimeout(function () {
          childrenInline.value = childrenMore.value;
          sessionVars.children = childrenMore.value;
          updateValueDisplayed();

          // debouncedSessionUpdate();
        }, 200);
      });
    });
  }

  const updateValueDisplayed = () => {
    const valueDisplays = document.querySelectorAll("#search .value-displayed");
    if (valueDisplays) {
      valueDisplays.forEach(function (valueDisplay) {
        const wrapper = valueDisplay.closest(".input-number");
        if (wrapper) {
          const input = wrapper.querySelector(".personsInput");
          valueDisplay.textContent = input.value;
        }
      });
    }
  }
}

const initClickFromTracking = () => {
  window.addEventListener('click', (e) => {
    if(e.target.classList.contains('from-map') || e.target.classList.contains('from-list')){
      const from = e.target.classList.contains('from-map') ? 'map' : 'list';
      localStorage.setItem('trackFrom', from);
    }
  });
}

//TODO > Replace this with the one in utils.js
const groupBy = (array, f) => {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  })
}

// const updateSession = () => {
  // const data = new FormData();
  // data.append('adults', sessionVars.adults);
  // data.append('children', sessionVars.children);
  // data.append('from', sessionVars.from instanceof Date ? dateToString(sessionVars.from) : '');
  // data.append('to', sessionVars.to instanceof Date ? dateToString(sessionVars.to) : '');
  // data.append('langs', JSON.stringify(sessionVars.langs));

  // ajax(search.dataset.sessionUrl, function () { }, 'POST', data, {
  //   "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content,
  // });
// }

const initSearch = () => {
  const search = document.getElementById("searchPage");
  if(search) {

    initFilters();
    initToggleMap();

    if(document.body.dataset.isBot === 'false'){
      initMap();
    }

    initPersonsInput();
    initActivePersons();
    initActiveFilters();
    initSearchBar();
    initEvents();
    initAroundMe();
    initClickFromTracking();

    setActiveFiltersFromSession();
  }
}

export { initSearch }
